import { medicationsActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_MEDICATION,
  FETCHING_MEDICATION,
  FETCH_MEDICATION_ERROR,
  FETCH_MEDICATIONS,
  FETCHING_MEDICATIONS,
  FETCH_MEDICATIONS_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_MEDICATION,
  DELETE_MEDICATION,
  ADD_MEDICATION,
  EDIT_MEDICATION,
  FORM_TOUCHED,
  NEW_FORM_MEDICATION,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  MEDICATION_FORM_ERROR,
  RESET_STATE
} = medicationsActions

const initialState = {
  loadingMedication: false,
  loadingMedications: false,
  fetchMedicationError: false,
  fetchMedicationsError: false,
  medications: [],
  order: {
    column: 'nome',
    direction: 1
  },
  medication: {
    nome: '',
    sinonimos: '',
    codigo_ean: '',
    nomeDcb_id: ''
  },
  medicationsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  medicationFormErrors: {},
  medicationFormTouched: false,
  modalOpen: false
}

const medicationSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    },
    codigo_ean: {
      required: false
    },
    sinonimos: {
      required: false
    },
    nomeDcb_id: {
      required: true
    },
    tipoMedicamento_id: {
      required: true
    },
    classificacaoMedicamento_id: {
      required: true
    },
    laboratorio_id: {
      required: false
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    },
    codigo_ean: {
      required: false
    },
    sinonimos: {
      required: false
    },
    nomeDcb_id: {
      required: true
    },
    tipoMedicamento_id: {
      required: true
    },
    classificacaoMedicamento_id: {
      required: true
    },
    laboratorio_id: {
      required: false
    }
  }
}

const MedicationValidate = new ValidateFormObject(medicationSchema)

const medications = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_MEDICATION:
      formSchemaType = action.medication._id ? 'edit' : 'add'
      return {
        ...state,
        medication: action.medication,
        medicationFormErrors: MedicationValidate.validate({
          formObject: action.medication,
          formSchemaType
        })
      }
    case MEDICATION_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.medication._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        medicationFormErrors: MedicationValidate.validate({
          formObject: state.medication,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_MEDICATION:
      return {
        ...state,
        medication: { ...initialState.medication },
        medicationFormErrors: MedicationValidate.validate({}),
        medicationFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        medicationFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_MEDICATION:
      formSchemaType = (action.medication || {})._id ? 'edit' : 'add'
      return {
        ...state,
        medication: action.medication,
        loadingMedication: false,
        fetchMedicationError: false,
        medicationFormTouched: false,
        medicationFormErrors: MedicationValidate.validate({
          formObject: action.medication,
          formSchemaType
        })
      }
    case FETCHING_MEDICATION:
      return {
        ...state,
        loadingMedication: true,
        fetchMedicationError: false
      }
    case DELETE_MEDICATION:
      return {
        ...state,
        loadingMedications: false,
        fetchMedicationError: false,
        medications: state.medications.map(medication => {
          if (medication._id === (action.medication || {})._id) {
            return action.medication
          }
          return medication
        })
      }
    case FETCH_MEDICATION_ERROR:
      return {
        ...state,
        loadingMedications: false,
        medication: { ...initialState.medication },
        fetchMedicationError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        medicationsPagination: {
          ...state.medicationsPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        medicationsPagination: {
          ...state.medicationsPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_MEDICATIONS:
      return {
        ...state,
        loadingMedications: false,
        medications: action.medications,
        fetchMedicationsError: false,
        order: action.order,
        medicationsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_MEDICATION:
      return {
        ...state,
        medications: state.medications.map(medication => {
          if (medication._id === action.medication._id) {
            return action.medication
          }
          return medication
        }),
        loadingMedications: false,
        fetchMedicationError: false,
        loadingMedication: false,
        fetchMedicationsError: false
      }
    case FETCHING_MEDICATIONS:
      return {
        ...state,
        loadingMedications: true,
        fetchMedicationsError: false
      }
    case FETCH_MEDICATIONS_ERROR:
      return {
        ...state,
        loadingMedications: false,
        fetchMedicationsError: action.error,
        loadingMedication: false
      }
    case ADD_MEDICATION:
      return {
        ...state,
        loadingMedications: false,
        fetchMedicationsError: false,
        loadingMedication: false,
        medications: [...state.medications, action.medication]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default medications



// WEBPACK FOOTER //
// ./src/reducers/medications.js